module.exports = __webpack_public_path__ + "img/hotel_no_data.1fa41788.png";